// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  getBeacon,
  putBeacon,
  getServer,
  postServerForceRestart,
  getIrCutFilter,
  putIrCutFilter,
  getIrLight,
  putIrLightAbsolute,
  postIrLightRelative,
  getZoom,
  putZoomAbsolute,
  postZoomRelative,
  putZoomReset,
  getFocus,
  putFocusAbsolute,
  postFocusRelative,
  putFocusReset,
  getAperture,
  putApertureAbsolute,
  postApertureRelative,
  putApertureReset,
  getCameras,
  putCameras,
  restartCameras,
  getEngine,
  getBattery,
  putHeartbeat,
  postRoofShutdown,
  postRoofForceShutdown,
  postRoofForceRestart,
} from '../sdk.gen'
import { queryOptions, type UseMutationOptions, type DefaultError } from '@tanstack/react-query'
import type {
  GetBeaconData,
  PutBeaconData,
  PutBeaconResponse,
  GetServerData,
  PostServerForceRestartData,
  GetIrCutFilterData,
  PutIrCutFilterData,
  PutIrCutFilterResponse,
  GetIrLightData,
  PutIrLightAbsoluteData,
  PutIrLightAbsoluteResponse,
  PostIrLightRelativeData,
  PostIrLightRelativeResponse,
  GetZoomData,
  PutZoomAbsoluteData,
  PutZoomAbsoluteResponse,
  PostZoomRelativeData,
  PostZoomRelativeResponse,
  PutZoomResetData,
  PutZoomResetResponse,
  GetFocusData,
  PutFocusAbsoluteData,
  PutFocusAbsoluteResponse,
  PostFocusRelativeData,
  PostFocusRelativeResponse,
  PutFocusResetData,
  PutFocusResetResponse,
  GetApertureData,
  PutApertureAbsoluteData,
  PutApertureAbsoluteResponse,
  PostApertureRelativeData,
  PostApertureRelativeResponse,
  PutApertureResetData,
  PutApertureResetResponse,
  GetCamerasData,
  PutCamerasData,
  PutCamerasResponse,
  RestartCamerasData,
  GetEngineData,
  GetBatteryData,
  PutHeartbeatData,
  PostRoofShutdownData,
  PostRoofForceShutdownData,
  PostRoofForceRestartData,
} from '../types.gen'
import { client as _heyApiClient } from './initializer'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const getBeaconQueryKey = (options?: Options<GetBeaconData>) => createQueryKey('getBeacon', options)

/**
 * Beacon state getter
 */
export const getBeaconOptions = (options?: Options<GetBeaconData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBeacon({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBeaconQueryKey(options),
  })
}

/**
 * Beacon state setter
 */
export const putBeaconMutation = (
  options?: Partial<Options<PutBeaconData>>
): UseMutationOptions<PutBeaconResponse, DefaultError, Options<PutBeaconData>> => {
  const mutationOptions: UseMutationOptions<PutBeaconResponse, DefaultError, Options<PutBeaconData>> = {
    mutationFn: async localOptions => {
      const { data } = await putBeacon({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getServerQueryKey = (options?: Options<GetServerData>) => createQueryKey('getServer', options)

/**
 * Server state getter
 */
export const getServerOptions = (options?: Options<GetServerData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getServer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getServerQueryKey(options),
  })
}

export const postServerForceRestartQueryKey = (options?: Options<PostServerForceRestartData>) =>
  createQueryKey('postServerForceRestart', options)

/**
 * Force server restart
 */
export const postServerForceRestartOptions = (options?: Options<PostServerForceRestartData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postServerForceRestart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postServerForceRestartQueryKey(options),
  })
}

/**
 * Force server restart
 */
export const postServerForceRestartMutation = (
  options?: Partial<Options<PostServerForceRestartData>>
): UseMutationOptions<unknown, DefaultError, Options<PostServerForceRestartData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostServerForceRestartData>> = {
    mutationFn: async localOptions => {
      const { data } = await postServerForceRestart({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getIrCutFilterQueryKey = (options: Options<GetIrCutFilterData>) =>
  createQueryKey('getIrCutFilter', options)

/**
 * IR-Cut Filter getter
 */
export const getIrCutFilterOptions = (options: Options<GetIrCutFilterData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIrCutFilter({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getIrCutFilterQueryKey(options),
  })
}

/**
 * IR-Cut Filter setter
 */
export const putIrCutFilterMutation = (
  options?: Partial<Options<PutIrCutFilterData>>
): UseMutationOptions<PutIrCutFilterResponse, DefaultError, Options<PutIrCutFilterData>> => {
  const mutationOptions: UseMutationOptions<PutIrCutFilterResponse, DefaultError, Options<PutIrCutFilterData>> = {
    mutationFn: async localOptions => {
      const { data } = await putIrCutFilter({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getIrLightQueryKey = (options: Options<GetIrLightData>) => createQueryKey('getIrLight', options)

/**
 * IR Light level getter
 */
export const getIrLightOptions = (options: Options<GetIrLightData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIrLight({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getIrLightQueryKey(options),
  })
}

/**
 * IR Light absolute level setter
 */
export const putIrLightAbsoluteMutation = (
  options?: Partial<Options<PutIrLightAbsoluteData>>
): UseMutationOptions<PutIrLightAbsoluteResponse, DefaultError, Options<PutIrLightAbsoluteData>> => {
  const mutationOptions: UseMutationOptions<
    PutIrLightAbsoluteResponse,
    DefaultError,
    Options<PutIrLightAbsoluteData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await putIrLightAbsolute({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postIrLightRelativeQueryKey = (options: Options<PostIrLightRelativeData>) =>
  createQueryKey('postIrLightRelative', options)

/**
 * IR Light relative level setter
 */
export const postIrLightRelativeOptions = (options: Options<PostIrLightRelativeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postIrLightRelative({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postIrLightRelativeQueryKey(options),
  })
}

/**
 * IR Light relative level setter
 */
export const postIrLightRelativeMutation = (
  options?: Partial<Options<PostIrLightRelativeData>>
): UseMutationOptions<PostIrLightRelativeResponse, DefaultError, Options<PostIrLightRelativeData>> => {
  const mutationOptions: UseMutationOptions<
    PostIrLightRelativeResponse,
    DefaultError,
    Options<PostIrLightRelativeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postIrLightRelative({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getZoomQueryKey = (options: Options<GetZoomData>) => createQueryKey('getZoom', options)

/**
 * Zoom level getter
 */
export const getZoomOptions = (options: Options<GetZoomData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getZoom({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getZoomQueryKey(options),
  })
}

/**
 * Zoom absolute level setter
 */
export const putZoomAbsoluteMutation = (
  options?: Partial<Options<PutZoomAbsoluteData>>
): UseMutationOptions<PutZoomAbsoluteResponse, DefaultError, Options<PutZoomAbsoluteData>> => {
  const mutationOptions: UseMutationOptions<PutZoomAbsoluteResponse, DefaultError, Options<PutZoomAbsoluteData>> = {
    mutationFn: async localOptions => {
      const { data } = await putZoomAbsolute({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postZoomRelativeQueryKey = (options: Options<PostZoomRelativeData>) =>
  createQueryKey('postZoomRelative', options)

/**
 * Zoom relative level setter
 */
export const postZoomRelativeOptions = (options: Options<PostZoomRelativeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postZoomRelative({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postZoomRelativeQueryKey(options),
  })
}

/**
 * Zoom relative level setter
 */
export const postZoomRelativeMutation = (
  options?: Partial<Options<PostZoomRelativeData>>
): UseMutationOptions<PostZoomRelativeResponse, DefaultError, Options<PostZoomRelativeData>> => {
  const mutationOptions: UseMutationOptions<PostZoomRelativeResponse, DefaultError, Options<PostZoomRelativeData>> = {
    mutationFn: async localOptions => {
      const { data } = await postZoomRelative({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reset zoom to zero (ignoring bounds)
 */
export const putZoomResetMutation = (
  options?: Partial<Options<PutZoomResetData>>
): UseMutationOptions<PutZoomResetResponse, DefaultError, Options<PutZoomResetData>> => {
  const mutationOptions: UseMutationOptions<PutZoomResetResponse, DefaultError, Options<PutZoomResetData>> = {
    mutationFn: async localOptions => {
      const { data } = await putZoomReset({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getFocusQueryKey = (options: Options<GetFocusData>) => createQueryKey('getFocus', options)

/**
 * Focus getter
 */
export const getFocusOptions = (options: Options<GetFocusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFocus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getFocusQueryKey(options),
  })
}

/**
 * Focus absolute level setter
 */
export const putFocusAbsoluteMutation = (
  options?: Partial<Options<PutFocusAbsoluteData>>
): UseMutationOptions<PutFocusAbsoluteResponse, DefaultError, Options<PutFocusAbsoluteData>> => {
  const mutationOptions: UseMutationOptions<PutFocusAbsoluteResponse, DefaultError, Options<PutFocusAbsoluteData>> = {
    mutationFn: async localOptions => {
      const { data } = await putFocusAbsolute({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postFocusRelativeQueryKey = (options: Options<PostFocusRelativeData>) =>
  createQueryKey('postFocusRelative', options)

/**
 * Focus relative level setter
 */
export const postFocusRelativeOptions = (options: Options<PostFocusRelativeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postFocusRelative({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postFocusRelativeQueryKey(options),
  })
}

/**
 * Focus relative level setter
 */
export const postFocusRelativeMutation = (
  options?: Partial<Options<PostFocusRelativeData>>
): UseMutationOptions<PostFocusRelativeResponse, DefaultError, Options<PostFocusRelativeData>> => {
  const mutationOptions: UseMutationOptions<PostFocusRelativeResponse, DefaultError, Options<PostFocusRelativeData>> = {
    mutationFn: async localOptions => {
      const { data } = await postFocusRelative({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reset focus to zero (ignoring bounds)
 */
export const putFocusResetMutation = (
  options?: Partial<Options<PutFocusResetData>>
): UseMutationOptions<PutFocusResetResponse, DefaultError, Options<PutFocusResetData>> => {
  const mutationOptions: UseMutationOptions<PutFocusResetResponse, DefaultError, Options<PutFocusResetData>> = {
    mutationFn: async localOptions => {
      const { data } = await putFocusReset({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getApertureQueryKey = (options: Options<GetApertureData>) => createQueryKey('getAperture', options)

/**
 * Aperture getter
 */
export const getApertureOptions = (options: Options<GetApertureData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAperture({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getApertureQueryKey(options),
  })
}

/**
 * Aperture absolute level setter
 */
export const putApertureAbsoluteMutation = (
  options?: Partial<Options<PutApertureAbsoluteData>>
): UseMutationOptions<PutApertureAbsoluteResponse, DefaultError, Options<PutApertureAbsoluteData>> => {
  const mutationOptions: UseMutationOptions<
    PutApertureAbsoluteResponse,
    DefaultError,
    Options<PutApertureAbsoluteData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await putApertureAbsolute({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postApertureRelativeQueryKey = (options: Options<PostApertureRelativeData>) =>
  createQueryKey('postApertureRelative', options)

/**
 * Aperture relative level setter
 */
export const postApertureRelativeOptions = (options: Options<PostApertureRelativeData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postApertureRelative({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postApertureRelativeQueryKey(options),
  })
}

/**
 * Aperture relative level setter
 */
export const postApertureRelativeMutation = (
  options?: Partial<Options<PostApertureRelativeData>>
): UseMutationOptions<PostApertureRelativeResponse, DefaultError, Options<PostApertureRelativeData>> => {
  const mutationOptions: UseMutationOptions<
    PostApertureRelativeResponse,
    DefaultError,
    Options<PostApertureRelativeData>
  > = {
    mutationFn: async localOptions => {
      const { data } = await postApertureRelative({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reset aperture to zero (ignoring bounds)
 */
export const putApertureResetMutation = (
  options?: Partial<Options<PutApertureResetData>>
): UseMutationOptions<PutApertureResetResponse, DefaultError, Options<PutApertureResetData>> => {
  const mutationOptions: UseMutationOptions<PutApertureResetResponse, DefaultError, Options<PutApertureResetData>> = {
    mutationFn: async localOptions => {
      const { data } = await putApertureReset({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getCamerasQueryKey = (options?: Options<GetCamerasData>) => createQueryKey('getCameras', options)

/**
 * Camera getter
 */
export const getCamerasOptions = (options?: Options<GetCamerasData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCameras({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCamerasQueryKey(options),
  })
}

/**
 * Camera setter
 */
export const putCamerasMutation = (
  options?: Partial<Options<PutCamerasData>>
): UseMutationOptions<PutCamerasResponse, DefaultError, Options<PutCamerasData>> => {
  const mutationOptions: UseMutationOptions<PutCamerasResponse, DefaultError, Options<PutCamerasData>> = {
    mutationFn: async localOptions => {
      const { data } = await putCameras({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Camera restart
 */
export const restartCamerasMutation = (
  options?: Partial<Options<RestartCamerasData>>
): UseMutationOptions<unknown, DefaultError, Options<RestartCamerasData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<RestartCamerasData>> = {
    mutationFn: async localOptions => {
      const { data } = await restartCameras({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getEngineQueryKey = (options?: Options<GetEngineData>) => createQueryKey('getEngine', options)

/**
 * Engine state getter
 */
export const getEngineOptions = (options?: Options<GetEngineData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getEngine({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getEngineQueryKey(options),
  })
}

export const getBatteryQueryKey = (options?: Options<GetBatteryData>) => createQueryKey('getBattery', options)

/**
 * Battery voltage and charge percentage
 */
export const getBatteryOptions = (options?: Options<GetBatteryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBattery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getBatteryQueryKey(options),
  })
}

/**
 * Endpoint to listen for heartbeat of our services
 */
export const putHeartbeatMutation = (
  options?: Partial<Options<PutHeartbeatData>>
): UseMutationOptions<unknown, DefaultError, Options<PutHeartbeatData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PutHeartbeatData>> = {
    mutationFn: async localOptions => {
      const { data } = await putHeartbeat({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postRoofShutdownQueryKey = (options?: Options<PostRoofShutdownData>) =>
  createQueryKey('postRoofShutdown', options)

/**
 * Roof shutdown
 */
export const postRoofShutdownOptions = (options?: Options<PostRoofShutdownData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRoofShutdown({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postRoofShutdownQueryKey(options),
  })
}

/**
 * Roof shutdown
 */
export const postRoofShutdownMutation = (
  options?: Partial<Options<PostRoofShutdownData>>
): UseMutationOptions<unknown, DefaultError, Options<PostRoofShutdownData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostRoofShutdownData>> = {
    mutationFn: async localOptions => {
      const { data } = await postRoofShutdown({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postRoofForceShutdownQueryKey = (options?: Options<PostRoofForceShutdownData>) =>
  createQueryKey('postRoofForceShutdown', options)

/**
 * Force roof shutdown
 */
export const postRoofForceShutdownOptions = (options?: Options<PostRoofForceShutdownData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRoofForceShutdown({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postRoofForceShutdownQueryKey(options),
  })
}

/**
 * Force roof shutdown
 */
export const postRoofForceShutdownMutation = (
  options?: Partial<Options<PostRoofForceShutdownData>>
): UseMutationOptions<unknown, DefaultError, Options<PostRoofForceShutdownData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostRoofForceShutdownData>> = {
    mutationFn: async localOptions => {
      const { data } = await postRoofForceShutdown({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const postRoofForceRestartQueryKey = (options?: Options<PostRoofForceRestartData>) =>
  createQueryKey('postRoofForceRestart', options)

/**
 * Force roof restart
 */
export const postRoofForceRestartOptions = (options?: Options<PostRoofForceRestartData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await postRoofForceRestart({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: postRoofForceRestartQueryKey(options),
  })
}

/**
 * Force roof restart
 */
export const postRoofForceRestartMutation = (
  options?: Partial<Options<PostRoofForceRestartData>>
): UseMutationOptions<unknown, DefaultError, Options<PostRoofForceRestartData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostRoofForceRestartData>> = {
    mutationFn: async localOptions => {
      const { data } = await postRoofForceRestart({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}
